// extracted by mini-css-extract-plugin
export default {"brand":"_2zpL2wmy","StickyNavBar":"_3UzYNuMy","stickyNavBar":"_3UzYNuMy","ctaContainer":"_3BBXQfRB","StickyNavContent":"fkV3CbiP","stickyNavContent":"fkV3CbiP"};